<script>
    import tippy from "sveltejs-tippy";
    
    export let featureData;

    let activeTimesteps = [];

    $: {
        activeTimesteps = [];
        for (let [feat, steps] of Object.entries(featureData)) {
            for (let i = 0; i < steps.length; i++) {
                if (steps[i]) {
                    activeTimesteps[i] = true;
                }
            }
        }
    }
</script>

<style>
    .track {
        display: grid;
        grid-template-columns: 4fr repeat(10, 1fr);
        align-items: center;
    }
    .row-label {
        display: inline-block;
        text-align: right;
        text-transform: uppercase;
        font-size: 0.8rem;
    }
    .indicator {
        font-size: 1rem;
        font-weight: bold;
        padding: 0;
        border-radius: 0.75rem;
        text-align: center;
        width: calc(100% + 0.075rem); /* to slightly overlap neighbor to right */
        color: #ddd;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .indicator.active {
        color: #e24;
    }
</style>

<div class="track">
    <div class="row-label">
        <span use:tippy="{{content: 'Shows steps that have active features in any track'}}">
            <div class="help">&nbsp;</div>&nbsp;Timesteps</span>
    </div>
    {#each [1, 2, 3, 4, 5, 6, 7, 8] as val, i}
        <div class="indicator" class:active={activeTimesteps[i]}>{val}</div>
    {/each}
    <!-- extra elements for grid so it lines up -->
    <div></div>
    <div></div>
</div>